import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BestSeller, SummaryDaily, SummarySeller, SummaryService } from '../summary.service';

@Component({
  selector: 'app-summary-page',
  templateUrl: './summary-page.component.html',
  styleUrls: ['./summary-page.component.css']
})
export class SummaryPageComponent implements OnInit {

  constructor(private summary: SummaryService) { }
  dataSource!: BestSeller[];
  sellToDay!: BestSeller[];
  sellAmount: number = 0
  dataSourceDaily!: SummaryDaily[];
  sumAmount: number = 0;
  pipe = new DatePipe('en-US');
  ngOnInit(): void {
    let now = Date.now();
    let end = this.pipe.transform(now, 'y-MM-dd');
    let datePass = new Date();
    datePass.setDate(datePass.getDate() - 7)
    let start = this.pipe.transform(datePass, 'y-MM-dd')
    this.bestsellerForm.patchValue({
      start: start,
      end: end
    })
    this.summaryByDayForm.patchValue({
      start: start,
      end: end
    })
    this.productSellToDay()
  }
  bestsellerForm = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
  })
  summaryByDayForm = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
  })
  displayedColumns: string[] = ['index', 'product_id', 'name', 'sum'];
  displayedColumnsDaily: string[] = ['date', 'sum'];
  bestseller() {
    let dataForm = this.bestsellerForm.value;
    this.summary.getBestseller(dataForm.start, dataForm.end).subscribe((data) => {
      this.dataSource = data.best_seller;
      this.sumAmount = data.sum_amount;
    })
  }
  summaryByDay() {
    let dataForm = this.summaryByDayForm.value;
    let endDateForm = new Date(dataForm.end)
    endDateForm.setDate(endDateForm.getDate() + 1)
    let endDate = this.pipe.transform(endDateForm, 'y-MM-dd')
    this.summary.getDailySeller(dataForm.start, endDate).subscribe((data) => {
      this.dataSourceDaily = data
    })
  }
  productSellToDay() {
    let now = new Date();
    let addDay = now.setDate(now.getDate() + 1)
    let startDate = this.pipe.transform(new Date(), 'y-MM-dd')
    let endDate = this.pipe.transform(addDay, 'y-MM-dd')
    this.summary.getProductSellerToday(String(startDate), endDate).subscribe((data) => {
      this.sellToDay = data.best_seller;
      this.sellAmount = data.sum_amount;
    })
  }
}
